import React from "react";
import { Badge } from "../ui/badge";
import { STATUS_META } from "../../lib/gmaoConstants";

const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || { label: status, color: "bg-gray-100 text-gray-600 border-gray-200" };
  return (
    <Badge
      variant="outline"
      className={`${meta.color} font-medium`}
      data-testid={`status-badge-${status}`}
    >
      {meta.label}
    </Badge>
  );
};

export default StatusBadge;
